import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Navbar from "./Components/navbar/Navbar";

export default function PrivateRoutes() {
  const TOKEN = localStorage.getItem("SWAAccessToken");
  return TOKEN ? (
    <div>
      <Navbar /> <Outlet />
    </div>
  ) : (
    <Navigate to="/login" />
  );
}
